var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 18,
    height: 18,
    transform: "translate(-0.002)",
    fill: "#feb730"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linked_in",
    "data-name": "linked in",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(1.5 2.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M508.77,286.363c-1.539,0-1.769,1.205-1.769,2.44v4.711h-2.963v-9.521h2.843v1.3h.036a3.114,3.114,0,0,1,2.8-1.541c3,0,3.546,1.975,3.546,4.537v5.222H510.31v-4.629C510.31,287.782,510.287,286.363,508.77,286.363Z",
    transform: "translate(-498.983 -279.266)",
    fill: "#feb730"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 2.968,
    height: 9.521,
    transform: "translate(0.232 4.728)",
    fill: "#feb730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M499.013,277.769a1.716,1.716,0,1,1-1.715,1.71A1.71,1.71,0,0,1,499.013,277.769Z",
    transform: "translate(-497.298 -277.769)",
    fill: "#feb730"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.fdec39d58621b664509475507007790d.svg";
export { ForwardRef as ReactComponent };